import { computed, ref, nextTick } from 'vue'

import myConfig from '../../myConfig'
import { useHot } from "/@/kernel-mn/stores/useHot"
import { isApp, isIOS, getUrlParams } from '/@/kernel-mn/utils'
import {mb_copy} from "/@/plugins/global"

export function useInstall() {
  const { hotData } = useHot()
  const { tenantInfo } = hotData

  const appInstallReady = ref(false)
  const installServiceLoading = ref(false)

  const tid = computed(() => tenantInfo.value.tid)
  const downUrl = computed(() => {
    let downUrl = ''
    if (tenantInfo.value?.tenant) {
      if (isIOS()) { // ios的下载地址
        downUrl = tenantInfo.value.tenant.app_reg_addr
      } else { // android的下载地址
        downUrl = tenantInfo.value.tenant.official_addr
      }
    }
    return downUrl
  })
  const downUrlJson = computed(() => {
    let searchJSON = getUrlParams(window.location.href)
    if (searchJSON.code) {
      return searchJSON
    }
    if (window.queryCode) {
      return { code: window.queryCode }
    }
    if (tenantInfo.value.tenant) {
      if (isIOS()) { // ios的下载地址
        searchJSON = getUrlParams(tenantInfo.value.tenant.app_reg_addr)
      } else { // android的下载地址
        searchJSON = getUrlParams(tenantInfo.value.tenant.official_addr)
      }
    }
    return searchJSON
  })
  const appInstallKey = computed(() => {
    return tid.value ? myConfig.tenant[tid.value]?.['install'][myConfig.tenant[tid.value]?.['install'].used] : ''
  })
  const clipboardText = computed(() => {
    let appid = ''
    const clipboardParams = localStorage.getItem('clipboardParams') ? JSON.parse(localStorage.getItem('clipboardParams')) : {}
    const urlCode = clipboardParams.code
    return {
      appid,
      code: urlCode || '',
      channelCode: '',
    }
  })

  const downAppByClipboard = (e) => {
    const code = e.currentTarget.href.split('code=')[1] ? e.currentTarget.href.split('code=')[1] : clipboardText.value.code
    const clipboard = clipboardText.value.appid && code
    if (clipboard) {
      mb_copy(JSON.stringify(clipboardText.value))
    }
  }
  const initInstallation = () => {
    appInstallReady.value = !!window.appInstallReady
    // window.initInstallation 用来简单存储是否加载isntall的js的状态，存在vuex变量上刷新页面时值还是之前的值
    if (isApp() || !appInstallKey.value) return
    const installUsed = myConfig.tenant[tid.value]?.['install'].used
    if (window.initInstallation) {
      if (installUsed === 'openinstall') { // openinstall 配置的
        openInstallInit()
      } else if (installUsed === 'shareinstall' || installUsed === 'shareTraceInstall') { // shareinstall 配置的
        nextTick(() => {
          const buttons = document.getElementsByClassName('downloadButton')
          if (buttons) {
            for (let i = 0; i < buttons.length; i++) {
              buttons[i].addEventListener('click', function () {
                if (installUsed === 'shareinstall') {
                  window.initInstallationInstance.wakeupOrInstall()
                } else {
                  window.ShareTrace.download()
                }
              }, false)
            }
          }
        })
      }
      return
    }
    // 下载App代码
    let scriptFile = null
    if (installUsed === 'openinstall') {
      // 在这儿引入外部 openinstall
      scriptFile = document.createElement('script')
      scriptFile.type = 'text/javascript'
      scriptFile.src = 'https://web.cdn.openinstall.io/openinstall.js'
      document.body.appendChild(scriptFile)
    } else if (installUsed === 'shareinstall') {
      // 在这儿引入外部 shareinstall
      scriptFile = document.createElement('script')
      scriptFile.type = 'text/javascript'
      scriptFile.src = 'https://www.shareinstall.com.cn/js/page/jshareinstall.min.js'
      document.body.appendChild(scriptFile)
    } else if (installUsed === 'shareTraceInstall') {
      scriptFile = document.createElement('script')
      scriptFile.type = 'text/javascript'
      scriptFile.src = 'https://res.sharetrace.com/sharetrace.min.js'
      document.body.appendChild(scriptFile)
    }
    if (scriptFile) {
      if (installUsed === 'shareTraceInstall') {
        installServiceLoading.value = true
      }
      scriptFile.onload = () => {
        if (installUsed === 'openinstall') { // openinstall 配置的
          openInstallInit()
        } else if (installUsed === 'shareinstall') { // shareinstall 配置的
          shareInstallInit()
        } else if (installUsed === 'shareTraceInstall') { // ShareTrace 配置的
          shareTraceInit()
        }
      }
      scriptFile.onerror = () => {
        installServiceLoading.value = false
      }
    }
    window.initInstallation = true
  }
  const shareInstallInit = () => {
    // eslint-disable-next-line
    new ShareInstall({
      appKey: appInstallKey.value,
      onready: function () {
        appInstallReady.value = true
        window.appInstallReady = true
        // shareinstall 不确定是否初始化成功，没有error 生命周期可以使用
        window.initInstallationInstance = this
        nextTick(() => {
          const buttons = document.getElementsByClassName('downloadButton')
          if (buttons) {
            for (let i = 0; i < buttons.length; i++) {
              buttons[i].addEventListener('click', function () {
                window.initInstallationInstance.wakeupOrInstall()
              }, false)
            }
          }
        })
      }
    }, downUrlJson.value)
  }
  const openInstallInit = () => {
    // eslint-disable-next-line
    new OpenInstall({
      appKey: appInstallKey.value,
      mask: function () {
        return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
      },
      onready: function () {
        appInstallReady.value = true
        window.appInstallReady = true
        // shareinstall 不确定是否初始化成功，没有error 生命周期可以使用
        const m = this
        nextTick(() => {
          const buttons = document.getElementsByClassName('downloadButton')
          for (let i = 0; i < buttons.length; i++) {
            buttons[i].style.visibility = 'visible'
            buttons[i].onclick = function () {
              m.wakeupOrInstall()
              return false
            }
          }
          m.schemeWakeup()
        })
      }
    }, downUrlJson.value)
  }
  const getParams = (obj) => {
    let str = ''
    const arr = Object.keys(obj)
    arr.forEach((key, index) => {
      if (index === (arr.length - 1)) {
        str += `${key}=${obj[key]}`
      } else {
        str += `${key}=${obj[key]}&`
      }
    })
    return str
  }
  const shareTraceInit = () => {
    if (window.ShareTrace) {
      let paramStr = ''
      if (typeof downUrlJson.value === 'object') {
        paramStr = getParams(downUrlJson.value)
      } else {
        paramStr = downUrlJson.value
      }
      window.ShareTrace.init({
        appkey: appInstallKey.value, // 此值必填
        param: paramStr,
        success: function () {
          installServiceLoading.value = false
          appInstallReady.value = true
          window.appInstallReady = true
          nextTick(() => {
            const buttons = document.getElementsByClassName('downloadButton')
            if (buttons) {
              for (let i = 0; i < buttons.length; i++) {
                buttons[i].addEventListener('click', function () {
                  window.ShareTrace.download()
                }, false)
              }
            }
          })
        },
        error: function (msg) {
          installServiceLoading.value = false
        }
      })
    }
  }

  return {
    appInstallReady,
    installServiceLoading,
    downUrl,
    downUrlJson,
    appInstallKey,
    initInstallation,
    clipboardText,
    downAppByClipboard,
  }
}